
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorSeccion } from './controlador';
    import _ from 'lodash';
    import { Utiles } from '@/__env/pluggins/event-bus';

    @Component( {
        name: "Componente",
        props: {},
        components: {}
    } )
    export default class Componente extends Vue
    {

        @Prop()
        public Controlador: ControladorSeccion;
        public get Buscador() { return this.Controlador.Buscador; }
        public get Seleccionados() { return this.Controlador.Seleccionados; }
        public get Estado() { return this.Controlador.Buscador.Estado; }

        Cerrar()
        {
            this.Seleccionados.clear();
        }

        public CargandoActivar: boolean = false;
        public CargandoPausar: boolean = false;
        public get OkActivo(): boolean { return this.Seleccionados.filter( x => x.Estado.esPausada ).hasRows(); }
        public get OkPausada(): boolean { return this.Seleccionados.filter( x => x.Estado.esActiva ).hasRows(); }

        public async Activar()
        {
            let items = this.Seleccionados.filter( x => x.Estado.esPausada );
            if ( !items.hasRows() )
                return;

            if ( await Utiles.Mensajes.SiNo( 'Activar publicaciones', `¿Está seguro de activar ${items.length} publicaciones?` ) )
            {
                this.CargandoActivar = true;
                for ( let p of items )
                {
                    await p.Activar();
                }
                this.Controlador.RecargarEstadistica();
                this.CargandoActivar = false;
            }
        }

        public async Pausar()
        {
            let items = this.Seleccionados.filter( x => x.Estado.esActiva );
            if ( !items.hasRows() )
                return;

            if ( await Utiles.Mensajes.SiNo( 'Pausar publicaciones', `¿Está seguro de pausar ${items.length} publicaciones?` ) )
            {
                this.CargandoPausar= true;
                for ( let p of items )
                {
                    await p.Pausar();
                }
                this.Controlador.RecargarEstadistica();
                this.CargandoPausar = false;
            }
        }

    }
